'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthBitHeader = require('@narvar/nth-bit-header');
var index = require('../../components/Language/index.js');
require('../../components/Spinner/Spinner.module.css.js');
var index$1 = require('../../components/Icon/index.js');
require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
require('../../components/ItemCard/ItemCard.js');
var SelectItem = require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../components/ErrorBanner/ErrorBanner.js');
var Footer = require('../../components/Footer/Footer.js');
var StickyFooter = require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
require('@babel/runtime/helpers/extends');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/Backdrop.module.css.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var PudoCardSkeleton = require('../../components/Skeleton/PudoCardSkeleton.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var tokens = require('./tokens.js');
var Currency = require('../../transformers/Currency.js');
var RefundMethodsRaw_module = require('./RefundMethodsRaw.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RefundMethodsRaw = _ref => {
  let {
    showIncentive,
    showRefundAmounts: showRefundAmountsProp,
    refundOptions,
    selectedRefundMethod,
    error,
    loading,
    progressiveStep,
    activeStep,
    locale,
    includeCurrency,
    onBack,
    onChange,
    onSubmit
  } = _ref;
  const backLabel = useLanguage["default"]({
    langKey: 'returnsActionsBack'
  }).value;
  const nextLabel = useLanguage["default"]({
    langKey: 'returnsActionsNext'
  }).value;
  const hasDisclaimer = useLanguage["default"]({
    langKey: 'returnsRefundMethodsDisclaimer'
  }).value;
  const {
    panelcontainerNoneNone,
    bodytextDefaultNone,
    smalltextDefaultNone,
    selecteditemNoneNone,
    buttonsPrimaryDefault,
    buttonsSecondaryDisabled
  } = nthHookTheme.useTheme();
  const hasIncentive = showIncentive && (refundOptions === null || refundOptions === void 0 ? void 0 : refundOptions.some(opt => opt.incentive && opt.incentive.value > 0));
  const showRefundAmounts = showRefundAmountsProp || hasIncentive;
  const disabledColor = (buttonsSecondaryDisabled === null || buttonsSecondaryDisabled === void 0 ? void 0 : buttonsSecondaryDisabled.color) ?? '#999';
  const handleOnChangeFactory = option => () => {
    if (option.id !== (selectedRefundMethod === null || selectedRefundMethod === void 0 ? void 0 : selectedRefundMethod.id)) {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        area: 'refundMethods',
        event: 'change',
        value: {
          selectedRefundMethod: option
        }
      });
    }
  };
  const handleFooterEvent = event => {
    if (event.value === 'back') {
      onBack === null || onBack === void 0 ? void 0 : onBack({
        area: 'refundMethods',
        subComponent: 'footer',
        event: 'back',
        value: null
      });
    }
    if (event.value === 'next') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
        area: 'refundMethods',
        event: 'submit',
        value: {
          selectedRefundMethod
        }
      });
    }
  };
  if (loading) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].root
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].main
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].refundOptionList
    }, /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null), /*#__PURE__*/React__default["default"].createElement(PudoCardSkeleton.PudoCardSkeleton, null))));
  }
  if (error) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].root
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].main
    }, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, typeof error === 'string' || /*#__PURE__*/React.isValidElement(error) ? error : /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: "returnsStepsGeneralError"
    }))), /*#__PURE__*/React__default["default"].createElement(StickyFooter["default"], null, /*#__PURE__*/React__default["default"].createElement(Footer["default"], {
      progressiveStep: progressiveStep,
      activeStep: activeStep,
      onEvent: handleFooterEvent,
      buttons: {
        leftButton: {
          type: 'back',
          label: backLabel,
          outline: true
        },
        rightButton: {
          type: 'next',
          label: nextLabel,
          disabled: true
        }
      }
    })));
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: RefundMethodsRaw_module["default"].root
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: RefundMethodsRaw_module["default"].main
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    containerCustomStyle: {
      margin: '0.5rem 0 2rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsRefundMethodsTitle"
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: RefundMethodsRaw_module["default"].refundOptionList
  }, refundOptions === null || refundOptions === void 0 ? void 0 : refundOptions.map(_ref2 => {
    var _option$refund;
    let {
      render,
      ...option
    } = _ref2;
    const key = option.id;
    const selected = option.id === (selectedRefundMethod === null || selectedRefundMethod === void 0 ? void 0 : selectedRefundMethod.id);
    const pascalCase = function () {
      let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return str.split('_').map(s => (s[0] ?? '').toUpperCase() + s.substring(1).toLowerCase()).join('');
    };
    const type = pascalCase(option.type ?? '');
    const handleClick = option.disabled ? () => {} : handleOnChangeFactory(option);
    if (typeof render === 'function') {
      return render({
        ...option,
        key,
        selected,
        showIncentive: !!hasIncentive,
        showRefundAmounts: !!showRefundAmounts,
        onSelect: handleClick
      });
    }
    return /*#__PURE__*/React__default["default"].createElement(SelectItem["default"], {
      customStyle: {
        width: '100%',
        display: 'grid',
        columnGap: '32px',
        rowGap: '4px',
        gridTemplateColumns: showRefundAmounts ? 'auto 1fr auto' : 'auto 1fr',
        gridTemplateAreas: showRefundAmounts ? `
                    'Icon Title Amount'
                    'Icon Description Amount'` : `
                    'Icon Title'
                    'Icon Description'`,
        ...panelcontainerNoneNone
      },
      key: key,
      selected: selected,
      disabled: option.disabled,
      onClick: handleClick
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].iconGrid
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      icon: type
    })), /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].titleGrid
    }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsRefundMethodsOption${type}Title`,
      defaultString: option.name,
      style: option.disabled ? {
        color: disabledColor
      } : undefined
    }), hasIncentive && option.incentive && /*#__PURE__*/React__default["default"].createElement("span", {
      className: RefundMethodsRaw_module["default"].chip,
      style: {
        ...bodytextDefaultNone,
        ...smalltextDefaultNone,
        borderRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.borderRadius) ?? '4px',
        backgroundColor: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderTopColor) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor) ?? '#000',
        color: '#fff'
      }
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: "returnsRefundMethodsOptionIncentiveChip",
      replacementTokens: [{
        token: '{{amount}}',
        value: Currency.formatCurrency({
          locale,
          value: option.incentive.value,
          currency: option.incentive.currency
        })
      }]
    })))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].descriptionGrid
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsRefundMethodsOption${type}Description`,
      defaultString: option.description
    })), showRefundAmounts && typeof ((_option$refund = option.refund) === null || _option$refund === void 0 ? void 0 : _option$refund.value) === 'number' && /*#__PURE__*/React__default["default"].createElement("div", {
      className: RefundMethodsRaw_module["default"].amountGrid
    }, /*#__PURE__*/React__default["default"].createElement(Currency.Currency, {
      locale: locale,
      includeCurrency: includeCurrency,
      value: option.refund.value,
      currency: option.refund.currency
    })));
  })), hasDisclaimer && /*#__PURE__*/React__default["default"].createElement("div", {
    className: RefundMethodsRaw_module["default"].disclaimerText
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsRefundMethodsDisclaimer"
  }))), /*#__PURE__*/React__default["default"].createElement(StickyFooter["default"], null, /*#__PURE__*/React__default["default"].createElement(Footer["default"], {
    progressiveStep: progressiveStep,
    activeStep: activeStep,
    onEvent: handleFooterEvent,
    buttons: {
      leftButton: {
        type: 'back',
        label: backLabel,
        outline: true
      },
      rightButton: {
        type: 'next',
        label: nextLabel,
        disabled: !selectedRefundMethod
      }
    }
  })));
};
var RefundMethodsRaw$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(RefundMethodsRaw, {
  themeTokens: ['panelcontainerNoneNone', 'bodytextDefaultNone', 'buttonsPrimaryDefault', 'smalltextDefaultNone', 'selecteditemNoneNone', 'buttonsSecondaryDisabled']
}), {
  translationKeys: tokens.translationKeys
});

exports["default"] = RefundMethodsRaw$1;
